import React from 'react'
import { Box, Grid, Paper, styled, Typography } from '@mui/material'
import { AutoAwesomeOutlined, Insights, Public, ShieldOutlined, TrendingUp, Tune } from '@mui/icons-material'


const WCUCardStyled = styled(Box)(({ theme }) => ({
  width: '20vw',
  height: '30vh',
  padding: theme.spacing(2),
  color: 'antiquewhite',
  backgroundColor: '#242424',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  transition: 'all 0.3s ease',

  '&:hover': {
    backgroundColor: '#ffdd24',
    '& .hoverText': {
      color: '#242424',
    },
    '& .hoverIcon': {
      color: '#000',
    },
  },

  [theme.breakpoints.down('md')]: {
     width: '30vw',
  },
  [theme.breakpoints.down('sm')]: {
     width: '50vw',
  },
}));


const WCUCard = ({ title, description, Icon }) => {
  return (
    <WCUCardStyled>
      <Icon className='hoverIcon' sx={{ fontSize: '2.5rem', color: '#ffdd24', }} />
      <Typography variant='h6' fontWeight={900} className='hoverText' >{title}</Typography>
      <Typography variant='body2' className='hoverText' >{description}</Typography>
    </WCUCardStyled>
  );
}

function WhyChooseUs() {

  const WCUData = [
    {
      title: "Data You Can Trust",
      description:
        "We prioritize transparency, credibility, and cross-verified sources, no guesswork, no hidden assumptions.",
      icon: ShieldOutlined
    },
    {
      title: "Insights That Drive Action",
      description:
        "Our research turns complex data into executive-level strategies that directly support business growth and decision-making.",
      icon: TrendingUp
    },
    {
      title: "Customized Intelligence",
      description:
        "Every report is customized to your industry, goals, and markets, because one-size-fits-all doesn’t work in intelligence.",
      icon: Tune
    },
    {
      title: "Global Reach, Local Depth",
      description:
        "We offer worldwide coverage while delivering market intelligence rooted in regional realities, regulations, and nuances.",
      icon: Public
    },
    {
      title: "Forward-Thinking Foresight",
      description:
        "Our insights don’t just reflect today, we forecast what's next using trend modeling, scenario analysis, and investment indicators.",
      icon: Insights
    },
    {
      title: "Ethics-First Research",
      description:
        "We maintain complete confidentiality and never use commercial, promotional, or biased data sources, integrity is our baseline.",
      icon: AutoAwesomeOutlined
    }
  ];

  return (
    <Box
      sx={{
        width: "100%",
        py: 10,
        bgcolor: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 2
      }}
    >
      <Typography
        fontWeight={600}
        align="center"
        gutterBottom
        sx={{ fontSize: { md: "2.1rem", xs: "1.5rem" } }}
      >
        Why Choose Us
      </Typography>

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        columnSpacing={3}
        rowSpacing={3}
        sx={{ width: '90%' }}
      >
        {
          WCUData.map((data) => ((
            <WCUCard
              key={data.title}
              title={data.title}
              description={data.description}
              Icon={data.icon}
            />
          )))
        }
      </Grid>
    </Box>
  );
}

export default WhyChooseUs
